import { Paper, Title } from '@mantine/core';
import { useState } from 'react';

import {
  AdminTransactionSelectData,
  TransactionFilterForm,
} from '../../type/filter.types';

import { useForm } from '@mantine/form';
import AdminTransactionsDetails from '../../components/admin-transactions/admin-transaction-details.component';
import TransactionsTable from '../../components/admin-transactions/transactions-table.component';
import PartnerTransactionFilter from '../../components/filters/partner-transaction-filter.component';
import { IPaginationMeta } from '../../type/admin.types';
import {
  BasicTransactionResponseDetails,
  BasicTransactionResponseSummary,
  RetrieveAllTransactionsRequest,
  TransactionStats,
} from '../../type/retrieve-transaction.types';

const PartnerTransactionsPage = () => {
  const [paginationData, setPaginationData] = useState<IPaginationMeta>();
  const [isLoadResellers, setIsLoadResellers] = useState<boolean>(true);
  const [data, setData] = useState<BasicTransactionResponseSummary[]>([]);
  const [transactionStats, setTransactionStats] = useState<TransactionStats>();
  const [page, setPage] = useState<number>(1);
  const [transactionDetails, setTransactionDetails] =
    useState<BasicTransactionResponseDetails[]>();
  const [detailsPaginationData, setDetailsPaginationData] =
    useState<IPaginationMeta>();
  const [transactionSummaryRequest, setTransactionSummaryRequest] =
    useState<RetrieveAllTransactionsRequest>();
  const [transactionDetailsRequest, setTransactionDetailsRequest] =
    useState<RetrieveAllTransactionsRequest>();
  const [showTransactionSummary, setShowTransactionSummary] = useState(true);

  const [isChecked, setIsChecked] = useState<number[]>([]);
  const [checkedAll, setCheckedAll] = useState<boolean>(false);

  const filterSelectData = useForm<AdminTransactionSelectData>({
    initialValues: {
      partnersData: [],
      resellersData: [],
      merchantsData: [],
      merchantBranchesData: [],
      posData: [],
      transactionStatusData: [],
    },
  });

  const transactionFilterForm = useForm<TransactionFilterForm>({
    initialValues: {
      dateRange: [null, null],
      industryMid: '',
      transactionStatus: '',
      partner: '',
      reseller: '',
      merchant: '',
      merchantBranch: '',
      pos: '',
    },
  });

  return (
    <>
      {showTransactionSummary ? (
        <>
          <Title order={2} my='lg'>
            Transactions
          </Title>
          <div className='admin-transactions'>
            <Paper
              withBorder
              radius='md'
              shadow='lg'
              style={{
                flex: 1,
                height: '100%',
                padding: '20px 0',
                overflow: 'auto',
              }}
            >
              <PartnerTransactionFilter
                form={transactionFilterForm}
                setData={setData}
                setPaginationData={setPaginationData}
                page={page}
                setPage={setPage}
                filterSelectData={filterSelectData}
                setIsLoadResellers={setIsLoadResellers}
                isLoadResellers={isLoadResellers}
                setTransactionSummaryRequest={setTransactionSummaryRequest}
                transactionSummaryRequest={transactionSummaryRequest}
                data={data}
                isChecked={isChecked}
                setTransactionDetails={setTransactionDetails}
                setDetailsPaginationData={setDetailsPaginationData}
                setTransactionDetailsRequest={setTransactionDetailsRequest}
                setShowTransactionSummary={setShowTransactionSummary}
                setTransactionStats={setTransactionStats}
              />
              <TransactionsTable
                transactionStats={transactionStats}
                data={data}
                paginationData={paginationData}
                setPage={setPage}
                page={page}
                setTransactionDetails={setTransactionDetails}
                setShowTransactionSummary={setShowTransactionSummary}
                setDetailsPaginationData={setDetailsPaginationData}
                setTransactionDetailsRequest={setTransactionDetailsRequest}
                setIsLoadPartners={setIsLoadResellers}
                transactionSummaryRequest={transactionSummaryRequest}
                isChecked={isChecked}
                setIsChecked={setIsChecked}
                checkedAll={checkedAll}
                setCheckedAll={setCheckedAll}
              />
            </Paper>
          </div>
        </>
      ) : (
        <AdminTransactionsDetails
          transactionDetails={transactionDetails}
          detailsPaginationData={detailsPaginationData}
          transactionDetailsRequest={transactionDetailsRequest}
          setShowTransactionSummary={setShowTransactionSummary}
        />
      )}
    </>
  );
};

export default PartnerTransactionsPage;
